export enum InsignModuleRoutes {
    INSIGN_START = 'insign-confirm/start',
    INSIGN_FINISH = 'insign-confirm/finish'
}
